const getters = {
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  sidebar: state => state.app.sidebar,
  roles: state => state.user.roles,
  name: state => {
    const userName = state.user.name || localStorage.getItem('userName') || '';
    return userName;
  },
  menus: state => state.menu.menus,
  currentMenu: state => state.menu.currentMenuID,
  permission_routes: state => state.permission.routes,
}
export default getters
